import React, { Component } from "react";
import { connect } from "react-redux";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartItem from "../../components/CartItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import {
  removeCart,
  incCart,
  decCart,
  updateCartQuantity,
} from "../../store/actions/cart";

import styles from "../../thema/style";
import CheckoutCart from "../../components/CheckoutCart";
import "../../styles/ModernCart.css";
import { PUBLIC_DIR } from "../../config";
import calculatePrice from "../../helpers/calculatePrice";
import activeDiscount from "../../helpers/activeDiscount";
import { trackViewCart, trackRemoveFromCart } from "../../utils/analytics";
import { fetchCurrentPrices } from "../../utils/cartSync";

class CartDetail extends Component {
  state = {
    validatedItems: null,
    warnings: [],
    errors: [],
    validating: false,
  };

  async componentDidMount() {
    if (this.props.cart.items && this.props.cart.items.length > 0) {
      trackViewCart(this.props.cart.items);
      // Fetch current prices on page load
      await this.fetchPrices();
    }
  }

  async componentDidUpdate(prevProps) {
    // Refetch prices when cart changes
    const prevLength = prevProps.cart.items ? prevProps.cart.items.length : 0;
    const currentLength = this.props.cart.items ? this.props.cart.items.length : 0;

    if (prevLength !== currentLength) {
      await this.fetchPrices();
    }
  }

  fetchPrices = async () => {
    this.setState({ validating: true });

    const result = await fetchCurrentPrices(this.props.cart.items);

    this.setState({
      validatedItems: result.items,
      warnings: result.warnings || [],
      errors: result.errors || [],
      validating: false
    });
  };

  getValidatedItem = (item) => {
    // Find validated version of this item
    if (this.state.validatedItems) {
      const validated = this.state.validatedItems.find(v => v.id === item.id);
      if (validated) {
        return validated;
      }
    }
    return item;
  };

  getCurrentPrice = (item) => {
    const validated = this.getValidatedItem(item);
    return validated.current_price || validated.sale_price || validated.price;
  };

  calculateCustomerDiscount = (subtotal) => {
    const { customer } = this.props.customer;
    if (
      !customer ||
      !customer.discount_enabled ||
      subtotal < customer.min_cart_amount
    ) {
      return 0;
    }
    if (customer.discount_type === "percentage") {
      return subtotal * (customer.discount_value / 100);
    } else if (customer.discount_type === "fixed") {
      return customer.discount_value;
    }
    return 0;
  };

  render() {
    // Ara toplam (indirim uygulanmamış) - GUNCEL FIYATLARLA
    const cartTotalPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((v) => {
                const quantity = parseInt(v.quantity) || 0;
                const price = parseFloat(this.getCurrentPrice(v)) || 0;
                return quantity * price;
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    // Toplam fiyat (indirim uygulanmış) - GUNCEL FIYATLARLA
    const cartTotalDiscountPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((product) => {
                const validatedProduct = this.getValidatedItem(product);
                // validatedProduct'a quantity'yi ekle (fetchCurrentPrices quantity'yi kaybediyor)
                const productWithQuantity = {
                  ...validatedProduct,
                  quantity: product.quantity
                };
                return parseFloat(
                  calculatePrice(productWithQuantity, activeDiscount(product.categories))
                );
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    // Sepet indirimi: Sadece indirimli ürünlerin indirim tutarları toplamı
    const cartDiscount = this.props.cart.items.length > 0
      ? parseFloat(
          this.props.cart.items
            .map((item) => {
              const discount = activeDiscount(item.categories);
              if (!discount) return 0;

              const validatedItem = this.getValidatedItem(item);
              // item.quantity kullan (validatedItem.quantity değil)
              const quantity = parseInt(item.quantity) || 0;
              const basePrice = parseFloat(validatedItem.current_price || validatedItem.sale_price || validatedItem.price) || 0;

              if (discount.type === "percent") {
                return (basePrice * (discount.discount / 100)) * quantity;
              } else {
                return Math.min(discount.discount, basePrice) * quantity;
              }
            })
            .reduce((a, b) => a + b, 0)
            .toFixed(2)
        )
      : 0;

    // Customer discount (premium müşteri indirimi)
    const customerDiscount = this.calculateCustomerDiscount(
      cartTotalDiscountPrice
    );
    const finalCartPrice = cartTotalDiscountPrice - customerDiscount;

    // Shipping cost calculation
    const shippingCost =
      this.props.cart.items.length === 0 || finalCartPrice === 0
        ? 0
        : finalCartPrice >= this.props.setting.setting.free_shipping
        ? 0
        : this.props.setting.setting.shipping_cost;

    const totalWithShipping =
      this.props.cart.items.length === 0 ? 0 : finalCartPrice + shippingCost;

    return (
      <React.Fragment>
        <PageTitle title={"Sepet Detayları"} />
        <div className="row">
          <div className={"container mt-2"}>
            <div className="row">
              <div className={"col-md-9"}>
                <div
                  className={"row"}
                  style={{
                    marginTop: 10,
                    marginBottom: 50,
                  }}
                >
                  {this.props.cart.items.length === 0 ? (
                    <React.Fragment>
                      <div style={{ width: "100%" }}>
                        <div className="text-center py-5">
                          <FontAwesomeIcon
                            icon="shopping-cart"
                            size="4x"
                            className="text-muted mb-3"
                          />
                          <h3 className="text-muted mb-3">Sepetiniz Boş</h3>
                          <p className="text-muted">
                            Alışverişe başlamak için ürün kategorilerine göz
                            atabilirsiniz.
                          </p>
                        </div>
                      </div>
                    </React.Fragment>
                  ) : (
                    <div style={{ width: "100%" }}>
                      {/* Modern Tablo Tasarımı */}
                      <div className="modern-cart-table">
                        {/* Tablo Başlığı */}
                        <div className="modern-cart-header">
                          <div className="row py-3 border-bottom bg-light m-0">
                            <div className="col-2 text-center">
                              <strong>RESİM</strong>
                            </div>
                            <div className="col-4">
                              <strong>ÜRÜN ADI</strong>
                            </div>
                            <div className="col-2 text-center">
                              <strong>BİRİM FİYATI</strong>
                            </div>
                            <div className="col-2 text-center">
                              <strong>MİKTAR</strong>
                            </div>
                            <div className="col-1 text-center">
                              <strong>TOPLAM</strong>
                            </div>
                            <div className="col-1 text-center">
                              <strong></strong>
                            </div>
                          </div>
                        </div>

                        {/* Ürün Listesi */}
                        <div className="modern-cart-body">
                          {this.props.cart.items.map((item, i) => (
                            <div key={i} className="modern-cart-row">
                              <div className="row py-4 border-bottom align-items-center m-0">
                                {/* Ürün Görseli */}
                                <div className="col-2 text-center">
                                  <div className="product-img-wrapper">
                                    <img
                                      src={PUBLIC_DIR(item.image)}
                                      alt={item.name}
                                      className="modern-product-img"
                                      onError={(e) => {
                                        e.target.src =
                                          "https://via.placeholder.com/100x100?text=No+Image";
                                      }}
                                    />
                                    {activeDiscount(item.categories) && (
                                      <span className="cart-discount-badge">
                                        {activeDiscount(item.categories)
                                          .type === "percent"
                                          ? `%${
                                              activeDiscount(item.categories)
                                                .discount
                                            }`
                                          : `₺${
                                              activeDiscount(item.categories)
                                                .discount
                                            }`}
                                      </span>
                                    )}
                                  </div>
                                </div>

                                {/* Ürün Adı */}
                                <div className="col-4">
                                  <h6 className="mb-0 product-title">
                                    <Link
                                      to={`/urun/${item.slug}`}
                                      style={{
                                        color: "inherit",
                                        textDecoration: "none",
                                      }}
                                      onMouseEnter={(e) =>
                                        (e.target.style.color = "#667eea")
                                      }
                                      onMouseLeave={(e) =>
                                        (e.target.style.color = "inherit")
                                      }
                                    >
                                      {item.name}
                                    </Link>
                                  </h6>
                                </div>

                                {/* Birim Fiyat */}
                                <div className="col-2 text-center">
                                  {activeDiscount(item.categories) ? (
                                    <div className="price-with-discount">
                                      <span className="original-price">
                                        ₺
                                        {parseFloat(
                                          this.getCurrentPrice(item)
                                        ).toFixed(2)}
                                      </span>
                                      <span className="discounted-price">
                                        ₺
                                        {activeDiscount(item.categories)
                                          .type === "percent"
                                          ? parseFloat(
                                              this.getCurrentPrice(item) *
                                                (1 -
                                                  activeDiscount(
                                                    item.categories
                                                  ).discount /
                                                    100)
                                            ).toFixed(2)
                                          : parseFloat(
                                              this.getCurrentPrice(item) -
                                                activeDiscount(item.categories)
                                                  .discount
                                            ).toFixed(2)}
                                      </span>
                                    </div>
                                  ) : (
                                    <span className="product-price">
                                      ₺
                                      {parseFloat(
                                        this.getCurrentPrice(item)
                                      ).toFixed(2)}
                                    </span>
                                  )}
                                </div>

                                {/* Miktar Kontrolü */}
                                <div className="col-2 text-center">
                                  <div className="quantity-wrapper">
                                    <button
                                      className="qty-btn qty-minus"
                                      onClick={() => this.props.decCart(item)}
                                      disabled={parseInt(item.quantity) <= 1}
                                    >
                                      −
                                    </button>
                                    <input
                                      type="number"
                                      className="qty-input"
                                      value={parseInt(item.quantity) || 1}
                                      onChange={(e) => {
                                        const quantity = parseInt(
                                          e.target.value
                                        );
                                        if (quantity > 0) {
                                          this.props.updateCartQuantity(
                                            item,
                                            quantity
                                          );
                                        }
                                      }}
                                      min="1"
                                    />
                                    <button
                                      className="qty-btn qty-plus"
                                      onClick={() => this.props.incCart(item)}
                                    >
                                      +
                                    </button>
                                  </div>
                                  <small className="text-muted d-block mt-1">
                                    Adet
                                  </small>
                                </div>

                                {/* Toplam Fiyat */}
                                <div className="col-1 text-center">
                                  {activeDiscount(item.categories) ? (
                                    <div className="total-with-discount">
                                      <span className="original-total">
                                        ₺
                                        {(() => {
                                          const quantity =
                                            parseInt(item.quantity) || 1;
                                          const price =
                                            parseFloat(this.getCurrentPrice(item)) || 0;
                                          return (price * quantity).toFixed(2);
                                        })()}
                                      </span>
                                      <span className="product-total">
                                        ₺
                                        {(() => {
                                          const validatedItem = this.getValidatedItem(item);
                                          return calculatePrice(
                                            validatedItem,
                                            activeDiscount(item.categories)
                                          );
                                        })()}
                                      </span>
                                    </div>
                                  ) : (
                                    <span className="product-total">
                                      ₺
                                      {(
                                        this.getCurrentPrice(item) *
                                        item.quantity
                                      ).toFixed(2)}
                                    </span>
                                  )}
                                </div>

                                {/* Kaldır Butonu */}
                                <div className="col-1 text-center">
                                  <button
                                    className="remove-item-btn"
                                    onClick={() => {
                                      if (
                                        window.confirm(
                                          `${item.name} ürününü sepetinizden çıkarmak istediğinize emin misiniz?`
                                        )
                                      ) {
                                        // Analytics tracking - ürün sepetten çıkarılıyor
                                        trackRemoveFromCart(item, item.quantity);
                                        this.props.removeCart(item);
                                      }
                                    }}
                                    title="Sepetten Kaldır"
                                  >
                                    ×
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Modern Sipariş Özeti */}
                      <div className="modern-summary-section mt-4">
                        <div className="row">
                          {/* Sol Taraf - Kargo Bilgileri */}
                          <div className="col-md-7">
                            {finalCartPrice > 0 &&
                            finalCartPrice <
                              this.props.setting.setting.free_shipping ? (
                              <p className="shipping-notice text-end">
                                <strong>
                                  ₺
                                  {parseFloat(
                                    this.props.setting.setting.free_shipping
                                  ).toFixed(2)}
                                </strong>{" "}
                                TL ve Üzeri Ücretsiz Kargo
                                <br />
                                Ücretsiz kargo olması için{" "}
                                <strong>
                                  ₺
                                  {(
                                    this.props.setting.setting.free_shipping -
                                    finalCartPrice
                                  ).toFixed(2)}
                                </strong>{" "}
                                TL daha ürün ekleyin.
                              </p>
                            ) : finalCartPrice >=
                              this.props.setting.setting.free_shipping ? (
                              <p className="shipping-success text-end">
                                <strong>Ücretsiz kargo kazandınız!</strong>
                              </p>
                            ) : null}

                            {/* Premium Müşteri İndirimi Bilgilendirmesi */}
                            {this.props.customer.customer &&
                            this.props.customer.customer.discount_enabled ? (
                              finalCartPrice <
                              this.props.customer.customer.min_cart_amount ? (
                                <div className="premium-notice text-end mt-3">
                                  <div className="premium-header">
                                    <FontAwesomeIcon icon="star" className="me-2" />
                                    <strong>Premium Müşteri Avantajlarınız</strong>
                                  </div>
                                  <div className="premium-discount-info">
                                    <FontAwesomeIcon icon="check-circle" className="me-1" />
                                    <strong>
                                      ₺
                                      {this.props.customer.customer.discount_type ===
                                      "percentage"
                                        ? `${this.props.customer.customer.discount_value}%`
                                        : `${this.props.customer.customer.discount_value}`}
                                    </strong>{" "}
                                    tutarında özel indirim
                                  </div>
                                  <div className="premium-condition">
                                    Minimum sepet tutarı:{" "}
                                    <strong>
                                      ₺
                                      {parseFloat(
                                        this.props.customer.customer.min_cart_amount
                                      ).toFixed(2)}
                                    </strong>
                                    <br />
                                    Özel indiriminiz için{" "}
                                    <strong>
                                      ₺
                                      {(
                                        this.props.customer.customer.min_cart_amount -
                                        finalCartPrice
                                      ).toFixed(2)}
                                    </strong>{" "}
                                    TL daha ürün ekleyin.
                                  </div>
                                </div>
                              ) : (
                                <div className="premium-success text-end mt-3">
                                  <FontAwesomeIcon icon="star" className="me-2" />
                                  <strong>Premium müşteri indiriminiz aktif!</strong>
                                </div>
                              )
                            ) : null}
                          </div>

                          {/* Sağ Taraf - Fiyat Özeti */}
                          <div className="col-md-5">
                            <div className="price-summary-box">
                              <div className="price-line">
                                <span>Ara Toplam:</span>
                                <span>₺{cartTotalPrice.toFixed(2)}</span>
                              </div>

                              {cartDiscount > 0 && (
                                <div className="price-line discount">
                                  <span>Sepet İndirimi:</span>
                                  <span>-₺{cartDiscount.toFixed(2)}</span>
                                </div>
                              )}

                              {customerDiscount > 0 && (
                                <div className="price-line discount">
                                  <span>Premium Müşteri İndirimi:</span>
                                  <span>-₺{customerDiscount.toFixed(2)}</span>
                                </div>
                              )}

                              <div className="price-line">
                                <span>Kargo:</span>
                                <span>
                                  {shippingCost > 0 ? (
                                    `₺${shippingCost.toFixed(2)}`
                                  ) : (
                                    <span className="text-success">
                                      Ücretsiz
                                    </span>
                                  )}
                                </span>
                              </div>

                              {finalCartPrice >=
                                this.props.setting.setting.free_shipping && (
                                <div className="price-line free-shipping">
                                  <span>
                                    {parseFloat(
                                      this.props.setting.setting.free_shipping
                                    ).toFixed(2)}{" "}
                                    TL ve Üzeri Ücretsiz Kargo
                                  </span>
                                  <span className="text-danger">
                                    -₺
                                    {parseFloat(
                                      this.props.setting.setting.shipping_cost
                                    ).toFixed(2)}
                                  </span>
                                </div>
                              )}

                              <div className="price-line total">
                                <span>
                                  <strong>Toplam:</strong>
                                </span>
                                <span>
                                  <strong>
                                    ₺{totalWithShipping.toFixed(2)}
                                  </strong>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Modern Ödeme Butonu */}
                  <div className="checkout-button-wrapper mt-5">
                    <button
                      className={`modern-checkout-btn ${
                        this.props.cart.items.length === 0
                          ? "disabled"
                          : "active"
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        if (this.props.cart.items.length > 0) {
                          if (this.props.customer.customer) {
                            this.props.history.push({ pathname: "/odeme" });
                          } else {
                            this.props.history.push({
                              pathname: "/odeme/giris",
                            });
                          }
                        } else {
                          // Sepet boşsa ana sayfaya yönlendir
                          this.props.history.push({ pathname: "/" });
                        }
                      }}
                      type={"button"}
                    >
                      <div className="btn-content">
                        <div className="btn-icon">
                          <FontAwesomeIcon
                            icon={
                              this.props.cart.items.length === 0
                                ? "shopping-cart"
                                : "lock"
                            }
                          />
                        </div>
                        <div className="btn-text">
                          <div className="btn-main-text">
                            {this.props.cart.items.length === 0
                              ? "Alışverişe Başlayın"
                              : "Güvenli Ödemeye Geç"}
                          </div>
                          {this.props.cart.items.length > 0 && (
                            <div className="btn-price">
                              ₺{totalWithShipping.toFixed(2)}
                            </div>
                          )}
                        </div>
                        <div className="btn-arrow">
                          <FontAwesomeIcon icon="arrow-right" />
                        </div>
                      </div>
                    </button>

                    {this.props.cart.items.length > 0 && (
                      <div className="security-info">
                        <FontAwesomeIcon
                          icon="shield-alt"
                          className="security-icon"
                        />
                        <span>256-bit SSL ile güvenli ödeme</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className={"col-md-3"}>
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ cart, customer, setting }) => {
  return { cart, customer, setting };
};

const mapDispatchToProps = { removeCart, incCart, decCart, updateCartQuantity };

export default connect(mapStateToProps, mapDispatchToProps)(CartDetail);



// WEBPACK FOOTER //
// ./src/routers/CartDetail/index.js